module.exports = __webpack_public_path__ + "static/img/loading-bars.9b094768.svg";